export const EXPERIMENT_INIT = 'EXPERIMENT_INIT';
export const EXPERIMENT_SET_FLAGS = 'EXPERIMENT_SET_FLAGS';
export const EE_CANCEL_RETENTION_FLOW_SET = 'EE_CANCEL_RETENTION_FLOW_SET';
export const EE_REQUEST_GET = 'EE_REQUEST_GET';
export const EE_RECEIVE_GET_SUCCESS = 'EE_RECEIVE_GET_SUCCESS';
